import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class PageBreadcrumbService { 

    private breadcrumbList: any[];


    updateList(list: any){
        this.breadcrumbList = list;
    }

    getList(){
        return this.breadcrumbList;
    }
    
}